import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useTheme } from '../hooks/useTheme';

const NoticeListPage = () => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const { theme } = useTheme();

  useEffect(() => {
    // TODO: Replace with actual API call
    setNotices([
      {
        id: '1',
        title: '[Notice] Fansign Event for Juicy Luicy New Album',
        date: '2024-06-01',
        preview: 'Join our fansign event for the new album! Check details inside.',
        content: 'Full details about the fansign event for Juicy Luicy...'
      },
      {
        id: '2',
        title: '[Notice] Merch Pre-order Open!',
        date: '2024-05-20',
        preview: 'Official Juicy Luicy merch pre-order is now open. Limited stock!',
        content: 'Full details about the merch pre-order...'
      },
      {
        id: '3',
        title: '[Notice] Concert Announcement',
        date: '2024-05-10',
        preview: 'Juicy Luicy will be performing live in Jakarta. Get your tickets!',
        content: 'Full details about the concert...'
      }
    ]);
  }, []);

  return (
    <div className={`min-h-screen p-8 transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-gray-900 to-gray-800' 
        : 'bg-gradient-to-br from-gray-50 to-gray-200'
    }`}>
      <div className={`max-w-3xl mx-auto rounded-2xl shadow-lg p-8 transition-colors duration-300 ${
        theme === 'dark' 
          ? 'bg-gray-800/90 text-white' 
          : 'bg-white/90 text-gray-900'
      }`}>
        <h1 className={`text-4xl font-bold text-center mb-8 ${
          theme === 'dark' ? 'text-white' : 'text-gray-900'
        }`}>
          Notices
        </h1>
        
        <div className="flex flex-col gap-6">
          {notices.map(notice => (
            <div 
              key={notice.id} 
              className={`rounded-xl p-6 transition-all duration-300 cursor-pointer ${
                theme === 'dark'
                  ? 'bg-gray-700 hover:bg-gray-600 border-gray-600'
                  : 'bg-white hover:bg-gray-50 border-gray-100'
              } border hover:shadow-lg hover:-translate-y-1`}
              onClick={() => navigate(`/notices/${notice.id}`)}
            >
              <h2 className={`text-xl font-semibold mb-2 ${
                theme === 'dark' ? 'text-primary-light' : 'text-primary'
              }`}>
                {notice.title}
              </h2>
              <div className={`text-sm mb-2 ${
                theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
              }`}>
                {notice.date}
              </div>
              <p className={`text-base leading-relaxed ${
                theme === 'dark' ? 'text-gray-200' : 'text-gray-700'
              }`}>
                {notice.preview}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate(-1)}
            className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 inline-flex items-center gap-2 ${
              theme === 'dark' 
                ? 'bg-gradient-secondary text-white' 
                : 'bg-primary text-white'
            }`}
          >
            <FaArrowLeft /> Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeListPage; 